export interface BookingQueryParams {
	roomGuid?: string;
	dealGuid?: string;
	packageGuid?: string;
	accommodationTypes?: string;
	promotionCode?: string;
	languageCode?: string;
}

export class BookingRedirectHelper {
	private static readonly qParamMapping: Record<
		keyof BookingQueryParams,
		string
	> = {
		roomGuid: 'roomGUID',
		dealGuid: 'dealGUID',
		packageGuid: 'packageGUID',
		accommodationTypes: 'accommodationTypes',
		promotionCode: 'promotionCode',
		languageCode: 'languageCode',
	};

	/**
	 * Generates the correct booking tool redirect url based on the provided parameters.
	 * @param bookingToolUrl The base URL of the booking tool.
	 * @param hotelSlug The slug of the hotel.
	 * @param queryParams Optional query parameters for the booking tool.
	 *
	 * @returns The complete redirect URL for the booking tool.
	 */
	static getRedirectUrl(
		bookingToolUrl: string,
		hotelSlug: string,
		queryParams?: BookingQueryParams,
	): string {
		let redirectUrl = bookingToolUrl;

		if (hotelSlug) {
			redirectUrl += '?hotelSlug=' + hotelSlug;
		} else {
			// Redirect will not work without a hotel slug
			return bookingToolUrl;
		}

		if (queryParams) {
			for (const [key, urlParam] of Object.entries(this.qParamMapping)) {
				const value = queryParams[key as keyof BookingQueryParams];
				if (value) {
					redirectUrl += `&${urlParam}=${value}`;
				}
			}
		}

		return redirectUrl;
	}
}
